import { render, staticRenderFns } from "./CourseResourceView.vue?vue&type=template&id=07b77f3a&scoped=true"
import script from "./CourseResourceView.vue?vue&type=script&lang=js"
export * from "./CourseResourceView.vue?vue&type=script&lang=js"
import style0 from "./CourseResourceView.vue?vue&type=style&index=0&id=07b77f3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b77f3a",
  null
  
)

export default component.exports